import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PermissionsService } from 'src/app/services/permissions.service';
import { Department } from 'src/app/models/department.model';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button'; // Ensure Department type is imported

@Component({
  selector: 'app-create-wiki-node-dialog',
  templateUrl: './wiki-node-create-dialog.component.html',
  styleUrls: ['./wiki-node-create-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatSelect,
    MatOption,
    MatDialogActions,
    MatButton,
  ],
})
export class WikiNodeCreateDialogComponent implements OnInit {
  protected fb = inject(FormBuilder);
  private dialogRef = inject<MatDialogRef<WikiNodeCreateDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private permissionsService = inject(PermissionsService);

  form: FormGroup;
  availableDepartments: Department[] = []; // Specify type as Department[]
  isEditMode = false;

  constructor() {
    const data = this.data;

    this.isEditMode = !!data;

    // Set up the form with initial values
    this.form = this.fb.group({
      name: [data?.name || '', Validators.required],
      categories: [data?.allowed_department_ids || []],
    });
  }

  ngOnInit(): void {
    // Fetch the available categories (departments) from the permissions service
    this.availableDepartments = Object.values(this.permissionsService.getCurrentDepartments() || {}) as Department[]; // Type assertion to Department[]

    // If in edit mode, set form controls to existing data
    if (this.isEditMode && this.data?.element) {
      this.form.patchValue({
        name: this.data.element.name,
        categories: this.data.element.allowed_department_ids,
      });
    }
  }

  onConfirm(): void {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  isUserAdmin(): boolean {
    return this.permissionsService.isAdmin() ?? false;
  }
}
